<app-cargando *ngIf="loading"></app-cargando>

<div class="row" *ngIf="!loading">
  <div class="col-12">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center py-2">
        <h3 class="card-title mb-0"><i class="fas fa-cogs me-2"></i>Configuración del Sistema</h3>
        <button class="btn btn-success btn-sm" (click)="guardar()" [disabled]="saving">
          <i class="fas fa-save me-1"></i>Guardar Cambios
        </button>
      </div>

      <div class="card-body p-0">
        <!-- Tabs -->
        <ul class="nav nav-tabs nav-tabs-config px-3 pt-2">
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab==='empresa'" (click)="setTab('empresa')">
              <i class="fas fa-building me-1"></i>Empresa
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab==='sap'" (click)="setTab('sap')">
              <i class="fas fa-database me-1"></i>SAP
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab==='correo'" (click)="setTab('correo')">
              <i class="fas fa-envelope me-1"></i>Correo
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab==='pagina'" (click)="setTab('pagina')">
              <i class="fas fa-image me-1"></i>Página
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab==='indesad'" (click)="setTab('indesad')">
              <i class="fas fa-plug me-1"></i>INDESAD
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab==='sistema'" (click)="setTab('sistema')">
              <i class="fas fa-shield-alt me-1"></i>Sistema
            </a>
          </li>
        </ul>

        <div class="tab-content p-4">

          <!-- ===== EMPRESA ===== -->
          <div *ngIf="activeTab==='empresa'">
            <h5 class="mb-3 text-muted"><i class="fas fa-building me-2"></i>Datos de la Empresa</h5>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">RUT</label>
                <input type="text" class="form-control" [(ngModel)]="config.EMPRESA.RUT" placeholder="12.345.678-9">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Nombre</label>
                <input type="text" class="form-control" [(ngModel)]="config.EMPRESA.NOMBRE" placeholder="Nombre de la empresa">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">URL</label>
                <input type="text" class="form-control" [(ngModel)]="config.EMPRESA.URL" placeholder="https://...">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Teléfono</label>
                <input type="text" class="form-control" [(ngModel)]="config.EMPRESA.TELEFONO" placeholder="+56 9 ...">
              </div>
              <div class="col-12 mb-3">
                <label class="form-label">Dirección</label>
                <input type="text" class="form-control" [(ngModel)]="config.EMPRESA.DIRECCION" placeholder="Dirección completa">
              </div>
            </div>
          </div>

          <!-- ===== SAP ===== -->
          <div *ngIf="activeTab==='sap'">
            <h5 class="mb-3 text-muted"><i class="fas fa-database me-2"></i>Conexión SAP Business One</h5>
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label">Servidor</label>
                <input type="text" class="form-control" [(ngModel)]="config.SAP.SERVER" placeholder="IP o hostname">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Servidor SDL</label>
                <input type="text" class="form-control" [(ngModel)]="config.SAP.SERVER_SDL" placeholder="Servidor SDL">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Servidor Licencia</label>
                <input type="text" class="form-control" [(ngModel)]="config.SAP.SERVER_LICENCIA" placeholder="Servidor de licencia">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Tipo Base de Datos</label>
                <input type="text" class="form-control" [(ngModel)]="config.SAP.DATA_BASE_TYPE" placeholder="dst_MSSQL2019">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Base de Datos</label>
                <input type="text" class="form-control" [(ngModel)]="config.SAP.DATA_BASE" placeholder="Nombre DB">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">String de Conexión</label>
                <input type="text" class="form-control" [(ngModel)]="config.SAP.DATA_BASE_CONECTION_STRING" placeholder="Connection string">
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Usuario DB</label>
                <input type="text" class="form-control" [(ngModel)]="config.SAP.DATA_BASE_USER" placeholder="Usuario DB">
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Contraseña DB</label>
                <div class="input-group">
                  <input [type]="showPassDB ? 'text' : 'password'" class="form-control" [(ngModel)]="config.SAP.DATA_BASE_PASS">
                  <button class="btn btn-outline-secondary" type="button" (click)="showPassDB=!showPassDB">
                    <i class="fas" [ngClass]="showPassDB ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Usuario SAP</label>
                <input type="text" class="form-control" [(ngModel)]="config.SAP.USER" placeholder="manager">
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Contraseña SAP</label>
                <div class="input-group">
                  <input [type]="showPassSAP ? 'text' : 'password'" class="form-control" [(ngModel)]="config.SAP.PASS">
                  <button class="btn btn-outline-secondary" type="button" (click)="showPassSAP=!showPassSAP">
                    <i class="fas" [ngClass]="showPassSAP ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Reconnect SAP button -->
            <hr class="my-3">
            <div class="d-flex align-items-center gap-3">
              <button class="btn btn-warning" (click)="reiniciarConexionSAP()" [disabled]="reconnecting">
                <i class="fas" [ngClass]="reconnecting ? 'fa-spinner fa-spin' : 'fa-sync-alt'" class="me-1"></i>
                {{ reconnecting ? 'Reconectando...' : 'Reiniciar Conexión SAP' }}
              </button>
              <span *ngIf="sapStatus?.connected === true" class="badge bg-success"><i class="fas fa-check-circle me-1"></i>Conectado</span>
              <span *ngIf="sapStatus?.connected === false" class="badge bg-danger"><i class="fas fa-times-circle me-1"></i>Desconectado</span>
              <small *ngIf="sapStatus?.error" class="text-danger">{{ sapStatus.error }}</small>
            </div>
          </div>

          <!-- ===== CORREO ===== -->
          <div *ngIf="activeTab==='correo'">
            <h5 class="mb-3 text-muted"><i class="fas fa-envelope me-2"></i>Configuración de Correo SMTP</h5>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Correo</label>
                <input type="email" class="form-control" [(ngModel)]="config.CORREO.CORREO" placeholder="correo@empresa.com">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Contraseña</label>
                <div class="input-group">
                  <input [type]="showPassCorreo ? 'text' : 'password'" class="form-control" [(ngModel)]="config.CORREO.PASS">
                  <button class="btn btn-outline-secondary" type="button" (click)="showPassCorreo=!showPassCorreo">
                    <i class="fas" [ngClass]="showPassCorreo ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Servidor SMTP</label>
                <input type="text" class="form-control" [(ngModel)]="config.CORREO.SMTP" placeholder="smtp.gmail.com">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Puerto</label>
                <input type="number" class="form-control" [(ngModel)]="config.CORREO.PUERTO" placeholder="587">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">SSL</label>
                <div class="form-check form-switch mt-2">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="config.CORREO.SSL" id="sslSwitch">
                  <label class="form-check-label" for="sslSwitch">{{config.CORREO.SSL ? 'Activado' : 'Desactivado'}}</label>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Remitente (email)</label>
                <input type="email" class="form-control" [(ngModel)]="config.CORREO.REMITENTE" placeholder="noreply@empresa.com">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Nombre Remitente</label>
                <input type="text" class="form-control" [(ngModel)]="config.CORREO.REMITENTE_NOMBRE" placeholder="Nombre visible">
              </div>
            </div>
          </div>

          <!-- ===== PAGINA ===== -->
          <div *ngIf="activeTab==='pagina'">
            <h5 class="mb-3 text-muted"><i class="fas fa-image me-2"></i>Imágenes y Rutas de Página</h5>
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Ruta Imagen Logo</label>
                <input type="text" class="form-control" [(ngModel)]="config.PAGINA.RUTA_IMAGEN_LOGO" placeholder="/assets/logo.png">
              </div>
              <div class="col-12 mb-3">
                <label class="form-label">Ruta Imagen Layout</label>
                <input type="text" class="form-control" [(ngModel)]="config.PAGINA.RUTA_IMAGEN_LAYOUT" placeholder="/assets/layout.png">
              </div>
              <div class="col-12 mb-3">
                <label class="form-label">Ruta Imagen Usuario No Encontrado</label>
                <input type="text" class="form-control" [(ngModel)]="config.PAGINA.RUTA_IMAGEN_USER_NOT_FOUND" placeholder="/assets/user-not-found.png">
              </div>
            </div>
          </div>

          <!-- ===== INDESAD ===== -->
          <div *ngIf="activeTab==='indesad'">
            <h5 class="mb-3 text-muted"><i class="fas fa-plug me-2"></i>Integración INDESAD / Loginsa</h5>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">API Key</label>
                <input type="text" class="form-control" [(ngModel)]="config.INDESAD.API_KEY" placeholder="API Key INDESAD">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">API Loginsa</label>
                <input type="text" class="form-control" [(ngModel)]="config.INDESAD.API_LOGINSA" placeholder="Endpoint API Loginsa">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Licencias</label>
                <input type="number" class="form-control" [(ngModel)]="config.INDESAD.LICENCIAS">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Numeración Doc. Preliminar</label>
                <input type="number" class="form-control" [(ngModel)]="config.INDESAD.numeracionDocumentoPreliminal">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">URL API Loginsa</label>
                <input type="text" class="form-control" [(ngModel)]="config.INDESAD.urlAPILoginsa" placeholder="https://...">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Usuario Loginsa</label>
                <input type="text" class="form-control" [(ngModel)]="config.INDESAD.usuarioLoginsa">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Contraseña Loginsa</label>
                <div class="input-group">
                  <input [type]="showPassLoginsa ? 'text' : 'password'" class="form-control" [(ngModel)]="config.INDESAD.passLoginsa">
                  <button class="btn btn-outline-secondary" type="button" (click)="showPassLoginsa=!showPassLoginsa">
                    <i class="fas" [ngClass]="showPassLoginsa ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <!-- empty spacer -->
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Warehouse ID (whseid)</label>
                <input type="text" class="form-control" [(ngModel)]="config.INDESAD.whseid">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Storer Key</label>
                <input type="text" class="form-control" [(ngModel)]="config.INDESAD.storerkey">
              </div>
            </div>
          </div>

          <!-- ===== SISTEMA ===== -->
          <div *ngIf="activeTab==='sistema'">
            <h5 class="mb-3 text-muted"><i class="fas fa-shield-alt me-2"></i>Opciones del Sistema</h5>
            <div class="row">
              <div class="col-md-6 mb-3">
                <div class="card bg-dark border-secondary">
                  <div class="card-body">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="config.IsSystemBlocked" id="sysBlock">
                      <label class="form-check-label" for="sysBlock">
                        <strong>Bloquear Sistema</strong>
                      </label>
                    </div>
                    <small class="text-muted d-block mt-1">
                      Si se activa, se bloqueará el acceso a todos los usuarios del sistema.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Footer con botón guardar -->
      <div class="card-footer text-end py-2">
        <button class="btn btn-success" (click)="guardar()" [disabled]="saving">
          <i class="fas fa-save me-1"></i>Guardar Cambios
        </button>
      </div>
    </div>
  </div>
</div>
